export function NoiseOverlay() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-screen"
      style={{
        backgroundImage:
          "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.06) 0, transparent 33%), radial-gradient(circle at 80% 40%, rgba(255,255,255,0.04) 0, transparent 28%), radial-gradient(circle at 50% 80%, rgba(255,255,255,0.05) 0, transparent 30%)",
      }}
    />
  );
}
